export default __webpack_public_path__ + "static/media/Background_00108.5db36c1b.png";